<div class="border-grey-light header-container">
  <div class="row gap-22 mobile-row">
    <div class="col-md col-2 col-xs-4 border-blue"></div>

    <div class="col-md col-2 col-xs-4 border-blue"></div>

    <div class="col-md col-2 col-xs-4 border-grey"></div>

    <div class="col-md col-2 col-xs-4 border-grey"></div>
  </div>

  <div class="row d-flex justify-content-end mg-top-8">
    <p>Passo 2 de 4</p>
  </div>
  <h5 class="mg-top-16 mg-bottom-16">Confirmação dos dados cadastrais</h5>
  <p class="p-text-grey mg-bottom-32">
    Revise e confirme se os dados complementares estão corretos e atualizados.
  </p>
</div>

<div class="padding-16">
  <div class="row mg-bottom-16">
    <h6>Dados dos sócios</h6>
  </div>

  <div class="row d-flex justify-content-between">
    <p class="p-text-grey">
      Confirme os dados dos sócios e informe a porcentagem de participação
      societária, caso necessário.
    </p>
    <p class="p-text-grey">* Campos obrigatórios</p>
  </div>
</div>

<div class="padding-16">
  <div class="row">
    <h6>Sócios</h6>
  </div>
</div>

<form *ngFor="let form of forms" [formGroup]="form">
  <div class="row container-step-2 border-grey-light mg-bottom-16">
    <div class="col-md-8">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Nome do(a) sócio (a) *</mat-label>
        <input
          matInput
          formControlName="firstName"
          type="text"
          class=""
          name="firstName"
          required
        />
      </mat-form-field>
    </div>

    <div class="col-md-2">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>CPF *</mat-label>
        <input
          matInput
          formControlName="document"
          mask="000.000.000-00"
          type="text"
          class=""
          name="document"
          required
        />
      </mat-form-field>
    </div>

    <div class="col-md-2">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Participação societária</mat-label>
        <input
          label
          matInput
          formControlName="participation"
          currencyMask
          [options]="{
            align: 'left',
            prefix: '',
            thousands: '.',
            decimal: ',',
            suffix: ' %'
          }"
          type="text"
          class=""
          name="participation"
          required
        />
      </mat-form-field>
    </div>

    <div [hidden]="data.length === 1" class="col-md-12">
      <mat-checkbox formControlName="hasCompanyControl" name="first-name">
        <p class="p-text-grey">Pode assinar pela empresa.</p>
      </mat-checkbox>
    </div>

    <ng-container *ngIf="form.value.hasCompanyControl">
      <div class="col-md-12 text-socio">
        <h6>Informe alguns dados do (a) sócio</h6>
      </div>

      <div class="col-md-4 d-flex gap-10">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>CEP</mat-label>
          <input
            (input)="setAddress(form)"
            matInput
            type="tel"
            maxlength="10"
            mask="00000-000"
            placeholder="00000-000"
            formControlName="postalCode"
            type="text"
            name=""
            required
          />
          <mat-error
            *ngIf="
              form.controls.postalCode.touched &&
              form.controls.postalCode.errors?.required
            "
          >
            CEP obrigatório
          </mat-error>
        </mat-form-field>
        <span
          *ngIf="loadingCep"
          class="spinner-border spinner-border-sm mg-top-20"
        ></span>
      </div>

      <ng-container
        *ngIf="form.value.hasCompanyControl && form.value.line1 != null"
      >
        <div class="col-md-6">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Endereço</mat-label>
            <input
              matInput
              formControlName="line1"
              type="text"
              class=""
              name=""
              required
            />
            <mat-error
              *ngIf="
                form.controls.line1.touched &&
                form.controls.line1.errors?.required
              "
            >
              Endereço obrigatório
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-md-2">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Número</mat-label>
            <input
              matInput
              formControlName="number"
              oninput="validity.valid||(value='');"
              type="number"
              class=""
              name=""
              required
            />
            <mat-error
              *ngIf="
                form.controls.number.touched &&
                form.controls.number.errors?.required
              "
            >
              Número obrigatório
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-md-3">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Bairro</mat-label>
            <input
              matInput
              formControlName="line3"
              type="text"
              class=""
              name=""
              required
            />
            <mat-error
              *ngIf="
                form.controls.line3.touched &&
                form.controls.line3.errors?.required
              "
            >
              Bairro obrigatório
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-md-3">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Complemento</mat-label>
            <input
              matInput
              formControlName="line2"
              type="text"
              class=""
              name=""
            />
          </mat-form-field>
        </div>

        <div class="col-md-3">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Cidade</mat-label>
            <input
              matInput
              formControlName="city"
              type="text"
              class=""
              name=""
              required
            />
            <mat-error
              *ngIf="
                form.controls.city.touched &&
                form.controls.city.errors?.required
              "
            >
              Cidade obrigatória
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-md-3">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Estado</mat-label>
            <input
              matInput
              formControlName="state"
              type="text"
              class=""
              name=""
              required
            />
            <mat-error
              *ngIf="
                form.controls.state.touched &&
                form.controls.state.errors?.required
              "
            >
              Estado obrigatório
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-md-2">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Telefone</mat-label>
            <input
              matInput
              formControlName="phoneNumber"
              mask="(00) 00000-0000"
              type="text"
              class=""
              name=""
              required
            />
            <mat-error
              *ngIf="
                form.controls?.phoneNumber.touched &&
                form.controls?.phoneNumber.errors?.required
              "
            >
              Telefone obrigatório
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-md-4">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>E-mail</mat-label>
            <input
              matInput
              formControlName="email"
              type="text"
              class=""
              name=""
              required
            />
            <mat-error
              *ngIf="
                form.controls?.email.touched &&
                form.controls?.email.errors?.required
              "
            >
              Email obrigatório
            </mat-error>
          </mat-form-field>
        </div>
      </ng-container>
    </ng-container>

    <div></div>

    <div class="col-md-12">
      <div class="row d-flex">
        <mat-radio-group
          class="w-100"
          formControlName="isFATCA"
          (change)="requiredSSN(form, form.value.isFATCA)"
        >
          <div class="row-question">
            <mat-label>Tem relação com FATCA?</mat-label>
            <img
              (click)="openFatcaModal()"
              src="assets/image/question-icon.svg"
            />
          </div>

          <div class="row align-items-radios">
            <div class="radios-btns-form">
              <mat-radio-button [value]="false">Não</mat-radio-button>
              <mat-radio-button [value]="true">Sim</mat-radio-button>
            </div>
            <div>
              <ng-container *ngIf="form.value.isFATCA">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Número de cadastro S.S.N / TIN</mat-label>
                  <input
                    matInput
                    formControlName="identificationNumber"
                    type="text"
                    class=""
                    maxlength="20"
                    name="identificationNumber"
                    required
                  />
                  <mat-error
                    *ngIf="
                      form.controls.identificationNumber.touched &&
                      form.controls.identificationNumber.errors?.required
                    "
                  >
                    Número de cadastro S.S.N / TIN obrigatório
                  </mat-error>
                </mat-form-field>
              </ng-container>
            </div>
          </div>
        </mat-radio-group>
      </div>
    </div>

    <ng-container *ngIf="form.value.isFATCA">
      <div class="col-md-12 list-checkboxes">
        <div class="row">
          <mat-checkbox formControlName="bornAmerican" name="bornAmerican">
            <p class="p-text-grey-dark">
              Sou uma pessoa nascida nos EUA ou em seus territórios.
            </p>
          </mat-checkbox>
        </div>

        <div class="row">
          <mat-checkbox
            formControlName="naturalizedAmerican"
            name="naturalizedAmerican"
          >
            <p class="p-text-grey-dark">
              Sou uma pessoa americana naturalizado.
            </p>
          </mat-checkbox>
        </div>

        <div class="row">
          <mat-checkbox formControlName="hasGreenCard" name="hasGreenCard">
            <p class="p-text-grey-dark">Possuo Green Card.</p>
          </mat-checkbox>
        </div>

        <div class="row">
          <mat-checkbox
            formControlName="taxResidenceEUA"
            name="TaxResidenceEUA"
          >
            <p class="p-text-grey-dark">Possuo residência fiscal nos EUA.</p>
          </mat-checkbox>
        </div>

        <div class="row">
          <mat-checkbox
            formControlName="partnerInAmericanCompany"
            name="partnerInAmericanCompany"
          >
            <p class="p-text-grey-dark">
              Participo como sócio (a) acionista de empresa americana.
            </p>
          </mat-checkbox>
        </div>
      </div>
    </ng-container>
  </div>
</form>

<div
  class="row d-flex justify-content-between padding-bottom-32 padding-left-20 btns-footer"
>
  <button
    id="btn-primary-return"
    class="btn btn-block btn-outline-primary"
    type="button"
    (click)="goBack()"
  >
    Voltar
  </button>

  <button
    [style.width]="'auto'"
    [disabled]="!formsValid()"
    class="btn btn-dark-primary-blue"
    type="button"
    (click)="register()"
  >
    Avançar
    <span class="spinner-border spinner-border-sm" *ngIf="loading"></span>
  </button>
</div>
